var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qqwDetail"},[_c('van-skeleton',{attrs:{"title":"","row":10,"loading":_vm.loading}},[_c('div',{staticClass:"article-title"},[_vm._v(_vm._s(_vm.article.title))]),_c('div',{staticClass:"article-box",domProps:{"innerHTML":_vm._s(_vm.article.articleBody)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }